<template>
  <div style="padding-top: 10px">
    <!--    头部-->
    <Header>
      <!--  主体-->
    </Header>
    <div>
      <Aside2>
        <!--       侧边栏-->
      </Aside2>
      <!--     内容区域-->
      <router-view style="flex: 1;"></router-view>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";//注意一下..的数量
import Aside2 from "../components/Aside2";

export default {
  name: "homePage",
  components:{
    Header,
    Aside2
  }
}
</script>

<style scoped>

</style>
